<div class="h-full flex flex-col">
  <img class="m-auto" src="../../../../../assets/svg/loader.svg" alt="loader" />
</div>
